module.exports = __webpack_public_path__ + "d73963b3fa2c207a3d28d0901c351457.pdf";